import React from 'react';

import logo from '../../assets/logo-transparent.png';
import Container from '../Container/Container';

import styles from './Footer.module.scss';
import Logo from '../Logo/Logo';
import AddToCalendarButtons from '../AddToCalendarButtons/AddToCalendarButtons';

import useAuth from "../../hooks/useAuth";

const Footer = () => {
    const {user} = useAuth();
    const year = new Date().getFullYear();

    return (
        <Container className={styles.footer}>
            <div className={styles.container}>
                <Logo />
                <div className={styles.content}>
                    <h3>Сватбата на Камена и Христо</h3>
                    
                    {user && (
                        <>
                            <p>06.06.2026г.</p>
                            <AddToCalendarButtons buttonsClassName={styles.googleCalendarButton} />
                        </>
                    )}
                </div>
            </div>
            <div className={styles.copyright}>
                <p>Всички права запазени | Copyright © {year} | hristovi-wedding.com</p>
            </div>
        </Container>
    )
}

export default Footer;